import Axios, { AxiosRequestConfig } from 'axios';

import {
    addTokenRefreshInterceptor,
    captureClientErrorsToSentry,
    setTokenOnRequests,
    transformResponseToCamelCase,
} from './interceptors';

const DEFAULT_CONFIG: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_SERVER_BASE_URL ?? '',
    headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
    },
};

function getAxiosInstance() {
    const axiosInstance = Axios.create(DEFAULT_CONFIG);

    setTokenOnRequests(axiosInstance);
    transformResponseToCamelCase(axiosInstance);
    addTokenRefreshInterceptor(axiosInstance);
    captureClientErrorsToSentry(axiosInstance);

    return axiosInstance;
}

export const axios = getAxiosInstance();
